import { StorageUtil } from '@cleartax/wg-library-utils';
import { getCookie } from 'cookies-next';
import { SESSION_STORAGE_KEYS } from '../../../config/constants';
import { AY, CATEGORY_MARKETPLACE_WEBSITE } from './configs';
import {
  getAdditionalDataFromValue,
  getFunnelMetricParamsFromObject,
  getPrevLocation,
  getUTMParameters,
  handleConversions,
  sendFunnelMetrics,
  trackActionGA4
} from './utils';

// For now we are assuming we get an object of this shape
// We can create a util function to create this object
// using global state within the upstream consumer.
export type trackContextObject = {
  anonid?: string;
  emailid?: string;
  prevLocation?: string;
  label?: string;
};

export const trackAction = (
  action: string,
  value: unknown,
  trackContextObject: trackContextObject = {},
  category?: string
): void => {
  const { emailid, prevLocation, label } = trackContextObject;
  // create dataMap
  const v2Category = category ? category : 'mp-website-v2';
  const anonId = getCookie('anon_id');
  const dataMap = {
    category: CATEGORY_MARKETPLACE_WEBSITE,
    label: label ? label : window ? window.location.pathname : '',
    original_referrer: getPrevLocation(prevLocation ? prevLocation : ''),
    anonid: anonId ? anonId : 'anoynomous',
    _ay: AY,
    _t: new Date().getTime(),
    action: v2Category ? `${action}_${v2Category}` : action,
    email: emailid
      ? emailid
      : StorageUtil.getItem(SESSION_STORAGE_KEYS.USERNAME),
    ...getUTMParameters(),
    // handleMetadata
    ...(value ? { ...getAdditionalDataFromValue(value) } : {}),
  };

  sendFunnelMetrics(getFunnelMetricParamsFromObject(dataMap).join('&'));
  handleConversions(action);
  trackActionGA4(action, dataMap);
};
